import { Outlet } from "react-router-dom";

const ProtectedRoutesTrustben = () => {
  return <Outlet />;
};

export default ProtectedRoutesTrustben;
